module.exports = __webpack_public_path__ + "img/moodtrack2.4503ee5e.png";